import './AppTemplate.scss';

const AppTemplate = ({backendVersion, children}) => {
    return <div className='app-template'>
        {children}
        <div className="version">API {backendVersion ? `v. ${backendVersion}` : "not connected"}</div>
    </div>;
}
export default AppTemplate;